export default function Logo({ className = "w-9 h-9", color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
      style={color ? { color } : undefined}
      aria-label="Da Pra Assicurazioni"
      role="img"
    >
      <rect x="6" y="6" width="88" height="88" rx="4" ry="4" fill="none" stroke="currentColor" strokeWidth="5" />
      <polygon points="30,74 30,22 76,74" fill="currentColor" />
      <path d="M 14 80 Q 50 92 86 80 L 78 84 L 22 84 Z" fill="currentColor" />
    </svg>
  );
}
